import { ACTION } from "@/lib/auth/actions";
import type { Staff } from "@/lib/authv2/store";
import { hasPermission } from "@/lib/authv2/permissions";

type User = Pick<Staff, "role" | "department"> | null | undefined;

/** Same departments as the server's AllowOrDept for compose.backdrop.read (QĐ 0353). */
const READ_DEPARTMENTS = new Set(["retouch", "cskh", "marketing"]);

export const LY_DO_KHONG_QUAN_LY_ANH_NEN = "Chỉ marketing và quản lý được tải / sửa kho ảnh nền";

function department(user: User): string {
  return user?.department?.trim().toLowerCase() ?? "";
}

export function canReadBackdrops(user: User): boolean {
  return !!user && (hasPermission(ACTION.ComposeBackdropRead) || READ_DEPARTMENTS.has(department(user)));
}

/** Upload / switch off / re-group backdrops and edit the pre-written lines. */
export function canManageBackdrops(user: User): boolean {
  return !!user && (hasPermission(ACTION.ComposeBackdropManage) || department(user) === "marketing");
}
